// Actions en block images
document.addEventListener('DOMContentLoaded', function () {
    if (window.lucide) {
        lucide.createIcons();
    }

    document.querySelectorAll(".block-image").forEach(function (block) {
        const btn = block.querySelector(".btn-actions");
        const btnIcon = block.querySelector(".btn-actions i");
        const actions = block.querySelector(".selector-actions");

        if (btn && actions) {
            btn.addEventListener("click", () => {
                const isOpen = actions.classList.toggle("opened");

                btnIcon.classList.toggle("rotate-45", isOpen);
                actions.classList.toggle("opacity-100", isOpen);
                actions.classList.toggle("pointer-events-auto", isOpen);
                actions.classList.toggle("opacity-0", !isOpen);
                actions.classList.toggle("pointer-events-none", !isOpen);
            });
        }
    });
});
